import utf8 from "abusesa-js/utf8";

export function encode(state) {
    return btoa(utf8.encode(JSON.stringify(state))).replace(/\=/g, "");
}

export function decode(string) {
    return string ? JSON.parse(utf8.decode(atob(string))) : null;
}



// WEBPACK FOOTER //
// ./src/kpi/lib/State.js